<template>
<section>

	<!--
	<button v-on:click="deleteAllMaterials">Delete all materials</button>
-->

	<div class="d-flex justify-content-between align-items-center mt-2">
		<h3 class="mb-0">Materials</h3>
		
		<div v-if="!isFinalized">
			<!--
			<button v-if="mutatedAndCondensedMaterials.length > 0" class="btn btn-outline-danger mr-1" title="Delete all materials" v-on:click="deleteAllMaterials">
				<i class="fa fa-trash"></i>
				Delete All...
			</button>
			-->

			<button class="btn btn-success mr-1" v-on:click="selectorModal.visible = true">
				<i class="fa fa-plus"></i>
				Add Material
			</button>

			<button v-if="!hideRegenButton && !isQuoteSection" class="btn btn-light" title="Regenerate Materials" v-on:click="confirmRegen">
				<i class="fa fa-sync"></i>
			</button>
			
		</div>
	</div>

	<field v-if="hasAssemblies"
		class="mt-2 mb-2"
		:params="{type:'btn-group',buttons:[
			{text:'Assemblies',value:true},{text:'Raw Materials',value:false}
		],tabStyling:true}" 
		v-model="assemblyView">
	</field>

	<table-list v-if="hasAssemblies && assemblyView"
		:records="mutatedAssemblies"
		:fields="assemblyFields"
		:has-delete="!isFinalized"
		:has-edit="!isFinalized"
		:simple-delete="true"
		:sortable="true"
		:hide-record-count="true"
		:collapse-buttons="true"
		record-name="Assembly Item"
		v-on:delete="deleteAssembly"
		v-on:edit="editAssembly">

	</table-list>
	
	<table-list v-else
		:records="mutatedAndCondensedMaterials"
		:fields="materialsFields(hasAssemblies)"
		:has-delete="!isFinalized"
		:has-edit="!isFinalized"
		:simple-delete="false"
		:sortable="true"
		:hide-record-count="true"
		:records-selectable="!isFinalized"
		record-name="Material"
		record-locked-property="belongsToAssembly"
		v-on:delete="deleteMaterial"
		v-on:edit="editMaterial"
		:records-selected="selectedMaterials"
		v-on:selectedRecordsChange="setSelectedMaterials">

		<span style="display: none;">{{ selectedMaterials.length }} <!--required because Vue is not listening to this property unless it is rendered --></span>

		<material-bulk-controls v-if="selectedMaterials.length > 0 || clientInvoiceSettings.summaryMarkup == 1"
			:bulk-markup="bulkMarkup"
			:allow-bulk-price-adjustment="selectedMaterials.length > 0"
			:client-invoice-settings="clientInvoiceSettings"
			:selected-materials="selectedMaterials"
			:all-materials="mutatedAndCondensedMaterials"
			:invoice-id="billingDocumentId"
			:model="billingDocumentObjectResource"
			v-on:removeSelected="removeSelectedMaterials"
			v-on:bulkApplied="$emit('modelChanged')"
			v-on:autoDeselect="setSelectedMaterials([])">
		</material-bulk-controls>

	</table-list>

	<info-box class="float-right mt-2 mb-2" label="Total Materials $" :value="totalMaterials.toCurrency()"></info-box>
	<info-box class="float-right mt-2 mb-2" label="Total Labour (hrs)" :value="totalLabourHrs.toFixed(2)"></info-box>
	<div style="clear: both;"></div>

	<material-selector-modal 
		:visible="selectorModal.visible"
		:expense-log-prompt="false"
		:enable-labour="true"
		v-on:closeModal="selectorModal.visible = false"
		v-on:addMaterials="addMaterials">
	</material-selector-modal>

	<billing-document-material-edit-modal 
		:visible="materialEditModal.visible"
		:title="materialEditModal.title"
		:record="materialEditModal.record"
		:client-invoice-settings="clientInvoiceSettings"
		v-on:save="materialSave"
		v-on:closeModal="materialEditModal.visible = false">
	</billing-document-material-edit-modal>

	<billing-document-assembly-edit-modal
		:record="assemblyEditModal.payload"
		:visible="assemblyEditModal.visible"
		v-on:viewAssemblyDetails="viewAssemblyDetails"
		v-on:confirm="confirmAssemblyEdit"
		v-on:closeModal="assemblyEditModal.visible = false">
	</billing-document-assembly-edit-modal>

	<modal-dialog
		:modal-visible="setDefaultLabourModal.visible"
		title="Set Default Labour?"
		confirm-button-text="Yes"
		cancel-button-text="No"
		v-on:confirm="confirmSetDefaultLabour"
		v-on:closeModal="setDefaultLabourModal.visible = false">

		<p>Would you like to make <strong>{{setDefaultLabourModal.new_labour_hrs}}</strong> hrs the default labour value for part # <strong>{{ setDefaultLabourModal.part_number }}</strong>?</p>

	</modal-dialog>

	<modal-dialog :modal-visible="deleteConfirmModal.visible"
		title="Delete All Materials"
		confirm-button-text="Yes, Delete All Materials"
		button-class="btn-danger"
		:working="deleteConfirmModal.working"
		v-on:confirm="confirmDeleteAllMaterials"
		v-on:closeModal="deleteConfirmModal.visible = false">

		Are you sure you want delete all the materials and assemblies?

	</modal-dialog>

	<assembly-details-modal :readonly="true"
		:visible="assemblyDetailsModal.visible"
		:record="assemblyDetailsModal.record ? {
			id: assemblyDetailsModal.record.assembly_id,
			description: assemblyDetailsModal.record.description,
			unit_type: assemblyDetailsModal.record.unit_type,
			AssemblyTag: [],
			note_linear: assemblyDetailsModal.record.note_linear,
			note_segments: assemblyDetailsModal.record.note_segments,
			note_unit: assemblyDetailsModal.record.note_unit
		} : false"
		v-on:closeModal="closeDetailsModal">
	</assembly-details-modal>

</section>
</template>
<script type="text/javascript">
import MaterialSelectorModal from "@/components/super_components/MaterialSelectorModal"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import InfoBox from "@/components/InfoBox"
import MaterialBulkControls from "./MaterialBulkControls"
import BillingDocumentMaterialEditModal from "@/components/BillingDocumentMaterialEditModal"
import BillingDocumentAssemblyEditModal from "@/components/BillingDocumentAssemblyEditModal"
import AssemblyDetailsModal from "@/components/super_components/AssemblyDetailsModal"

import InvoiceMixins from "@/mixins/InvoiceMixins.js"
import AssemblyMixins from "@/mixins/AssemblyMixins.js"
import InvoiceMaterialMixins from "@/mixins/InvoiceMaterialMixins.js"

export default {
	name: "InvoiceMaterialSection",
	components: {
		MaterialSelectorModal,
		TableList,
		ModalDialog,
		Field,
		InfoBox,
		MaterialBulkControls,
		BillingDocumentMaterialEditModal,
		BillingDocumentAssemblyEditModal,
		AssemblyDetailsModal
	},
	mixins: [InvoiceMixins,AssemblyMixins,InvoiceMaterialMixins],
	props: [
		"isQuoteSection",
		"billingDocumentMaterials",
		"billingDocumentAssemblies",
		"billingDocumentId",
		"hideRegenButton",
		"clientInvoiceSettings",
		"billingDocumentObjectResource",
		"isFinalized"
	],
	data() {
		return {
			assemblyView: false,
			setDefaultLabourModal: {
				visible: false,
				new_labour_hrs: null,
				part_number: null,
				material_id: null
			},
			deleteConfirmModal: {
				visible: false,
				working: false
			}
		}
	},
	watch: {
		billingDocumentMaterials() {
			
		}
	},
	computed: {
		numSelectedMaterials() {
			return this.selectedMaterials.length
		},
		totalMaterials() {
			return this.mutatedAndCondensedMaterials.reduce((acc,mat) => {
				return acc + mat.totalRaw.round(2)
			},0)
		},
		totalLabourHrs() {
			let total = 0
			//Labour HRS * QTY / PER
			if (this.hasAssemblies && this.assemblyView) {
				total = this.mutatedAssemblies.reduce((acc,as) => {
					return acc + as.labourTotalRaw
				},0)
			}
			else if (this.billingDocumentMaterials) {
				total = this.billingDocumentMaterials.reduce((acc,mat) => {

					if (!("itemType" in mat) || mat.itemType != 'assembly')
						return acc + (+mat.labour_hrs * +mat.qty / +mat.per)
					else {
						let perAssemblyHrs = +mat.assembly.labour_hrs_per_assembly
						let perLineHrs = +mat.assembly.labour_hrs_per_unit * +mat.qty
						let perSegHrs = +mat.assembly.labour_hrs_per_segment * +mat.num_segments

						return acc + perAssemblyHrs + perLineHrs + perSegHrs
					}
				},0)
			}

			this.$emit("materialLabourChange",total)

			return total
		}
	},
	methods: {
		setSelectedMaterials(materials) {
			this.selectedMaterials = materials
		},
		editMaterial(record) {
			this.materialEditModal.visible = true
			this.materialEditModal.title = "Edit Material"
			this.materialEditModal.record = JSON.parse(JSON.stringify(record))		
			this.materialEditModal.currentLabourHrs = this.materialEditModal.record.labour_hrs
		},
		materialSave(modalData) {
			let vm = this

			if (modalData.payload.labour_hrs > 0 && this.materialEditModal.currentLabourHrs == 0) {
				this.setDefaultLabourModal.visible = true
				this.setDefaultLabourModal.new_labour_hrs = modalData.payload.labour_hrs
				this.setDefaultLabourModal.part_number = modalData.payload.part_number
				this.setDefaultLabourModal.material_id = modalData.payload.material_id
			}

			modalData.payload.invoice_id = this.billingDocumentId

			this.materialEditModal.visible = false

			//reset all the qtys of materials that have been condensed into this line item to 0, and then pick the first one and set the qty to the designated number
			let matsToUpdate = []
			if ("material_id" in modalData.payload && modalData.payload.material_id)
				matsToUpdate = this.billingDocumentMaterials.filter(mat => mat.material_id == modalData.payload.material_id)
			else if ("part_number" in modalData.payload && modalData.payload.part_number)
				matsToUpdate = this.billingDocumentMaterials.filter(mat => mat.part_number == modalData.payload.part_number)
			else if ("description" in modalData.payload && modalData.payload.description)
				matsToUpdate = this.billingDocumentMaterials.filter(mat => mat.description == modalData.payload.description)

			matsToUpdate.forEach((mat,index) => {
				if (mat.id == modalData.payload.id)
					this.saveObject(modalData,false,this.billingDocumentObjectResource)
				else
					vm.deleteObject(mat,vm.billingDocumentObjectResource)
			})
		},
		deleteMaterial(record) {
			//materials are condensed from multiple records, so we need to make sure we delete all of them
			let vm = this

			let matsToDelete = this.billingDocumentMaterials.filter(mat => mat.material_id == record.material_id)
			matsToDelete.forEach(mat => {
				vm.deleteObject(mat,vm.billingDocumentObjectResource)
			})
		},
		removeSelectedMaterials() {
			let vm = this

			let promises = []

			//are there assembly materials selected?
			if (this.selectedMaterials.find(mat => mat.belongsToAssembly)) {
				vm.alertFail("You cannot delete materials that belong to an assembly. You must delete the assembly itself")
			}

			else {
				this.selectedMaterials.forEach(item => {
					for (var i = 0; i < item.qty; i++)
						promises.push(vm.deleteObject(item,vm.billingDocumentObjectResource))
				})

				Promise.all(promises).then(responses => {
					vm.alertSuccess("Seleted materials removed")
					vm.selectedMaterials = []
				})
			}
		},
		confirmSetDefaultLabour() {
			let vm = this

			let payload = {
				id: this.setDefaultLabourModal.material_id,
				labour_hrs: this.setDefaultLabourModal.new_labour_hrs
			}

			this.postData("Material/save",payload).then(response => {
				if (response.success)
					vm.setDefaultLabourModal.visible = false
			})
		},
		confirmAssemblyEdit(payload) {
			this.assemblyEditModal.payload = payload
			this.saveAssemblyEdit()
		},
		deleteAllMaterials() {
			this.deleteConfirmModal.visible = true

		},
		confirmDeleteAllMaterials() {
			let promises = []
			let vm = this
			this.deleteConfirmModal.working = true

			this.billingDocumentMaterials.forEach(mat => {
				promises.push(this.postData(this.billingDocumentObjectResource+"/delete",{id:mat.id}))
			})

			Promise.all(promises).then(response => {
				vm.deleteConfirmModal.visible = false
				vm.deleteConfirmModal.working = false

				vm.$emit('modelChanged')
			})
		},
		disconnectChildMaterials() {
			let vm = this
			let promises = []

			this.billingDocumentMaterials.forEach(mat => {
				if ("belongsToAssembly" in mat && mat.belongsToAssembly && "parentAssemblies" in mat && mat.parentAssemblies) {
					let parentAsseblyRefIndex = mat.parentAssemblies.findIndex(ref => ref.assembly_id == vm.assemblyEditModal.payload.assembly_id)

					//remove it from the refs list
					mat.parentAssemblies.splice(parentAsseblyRefIndex,1)

					if (mat.parentAssemblies.length == 0)
						delete mat.parentAssemblies

					mat.type = "Material"
					mat.belongsToAssembly = false

					let payloadContainer = {
						payload: mat,
					}

					//now we need to save this updated material record

					promises.push(vm.saveObject(payloadContainer,true,vm.billingDocumentObjectResource)) //suppress the emits so we can emit modelChanged only once at the end
				}
			})

			//now we need to flag this assembly as disconnected

			let assemblyPayload = vm.cloneObj(vm.assemblyEditModal.payload)
			
			assemblyPayload.type = "Assembly"
			assemblyPayload.isDisconnected = true

			let payloadContainer = {
				payload: assemblyPayload
			}

			promises.push(vm.saveObject(payloadContainer,true,vm.billingDocumentObjectResource))

			if (promises.length > 0) {
				Promise.all(promises).then(responses => {
					vm.$emit("modelChanged")
				})
			}

			vm.assemblyEditModal.visible = false
		}
	},
	created() {

	}
} 
</script>